/* sugar:assets/product-price.js@2.1.7 */
/*
 * product-price — paints the Product Price block from the shared price store.
 *
 * Everything it needs arrives in the block's JSON island; the arithmetic lives in
 * sugar-pricing.js, so the price, the subtotal and the buy button can never disagree.
 */
(function () {
  function mount(island) {
    if (island.dataset.mounted) return;
    island.dataset.mounted = 'true';

    let config;
    try {
      config = JSON.parse(island.textContent);
    } catch (e) {
      return;
    }

    const root = document.querySelector('[data-_sf="' + config.blockId + '"]');
    if (!root || !window.SugarPricing) return;

    const priceEl = root.querySelector('.price');
    const regular = root.querySelector('.price__regular .price-item--regular');
    const sale = root.querySelector('.price__sale .price-item--sale');
    const compare = root.querySelector('.price__sale .price-item-wrapper--compare .price-item--regular');
    const badges = root.querySelectorAll('[data-price-template]');
    /* Shopify's unit price line ("$5.00/ea"): the picked variant's own, hidden when it has none. */
    const unitLine = config.unitLines ? root.querySelector('.price .unit-price') : null;
    const unitText = unitLine ? unitLine.querySelector('.price-item') : null;

    const store = window.SugarPricing.store(config);

    function paintBadge(badge, state) {
      const template = badge.dataset.priceTemplate;
      const wantsDiscount = window.SugarPricing.hasTokens(template);
      const perUnit = !!window.SugarPricing.hasPerTokens && window.SugarPricing.hasPerTokens(template);

      /* A label built out of discount tokens has nothing to say at full price. */
      if (wantsDiscount && !state.onSale) {
        badge.hidden = true;
        return;
      }
      badge.hidden = false;
      /* [price_per:N] and [unit_price] describe the price itself, sale or not. */
      if (!wantsDiscount && !perUnit) return;

      const target = badge.querySelector('[data-price-text]') || badge;
      target.innerHTML = window.SugarPricing.fillTokens(template, state, config.format);
    }

    let stop;
    stop = store.subscribe(function (state) {
      /* A re-rendered section leaves this copy detached; the fresh island has taken over. */
      if (!root.isConnected) {
        if (stop) stop();
        return;
      }
      if (priceEl) {
        priceEl.classList.toggle('price--sold-out', !state.available);
        priceEl.classList.toggle('price--on-sale', state.onSale);
        priceEl.classList.toggle('price--no-compare', !state.onSale);
      }

      const fmt = (cents) => window.SugarPricing.formatMoney(cents, config.format, !!config.hideCents && cents % 100 === 0);
      const money = fmt(state.totalPrice);
      if (regular) regular.textContent = money;
      if (sale) sale.textContent = money;
      if (compare && state.onSale) {
        compare.textContent = fmt(state.totalCompare);
      }

      badges.forEach((badge) => paintBadge(badge, state));

      if (unitText && state.variantId) {
        const line = config.unitLines[state.variantId];
        unitLine.hidden = !line;
        if (line && unitText.innerHTML !== line) unitText.innerHTML = line;
      }
    });
  }

  function init() {
    document.querySelectorAll('script[data-sugar-price]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Section rendering swaps the markup out from under us in the theme editor. */
  document.addEventListener('shopify:section:load', init);
})();
